import * as React from "react";
import CriterionCard from "./CriterionCard";
import TreatmentOptionSelector from "./TreatmentOptionSelector";
import TreatmentViewer from "../commons/components/TreatmentViewer";
import TreatmentSelection from "../commons/model/treatment/TreatmentSelection";
import Treatment from "../commons/model/treatment/Treatment";
import { sanitize } from "../commons/utils/sanitize";

interface TreatmentCardProps {
  selection: TreatmentSelection;
  onTreatmentOptionChange?: (selection: TreatmentSelection) => any;
  printMode: boolean;
  demoMode?: boolean;
}

export default function TreatmentCard(props: TreatmentCardProps) {
  function byPosition(t1: Treatment, t2: Treatment) {
    return (
      (t1.assignments.find((it) => it.criteriaGroup.id === selection.criteriaGroup)?.position ??
        0) -
      (t2.assignments.find((it) => it.criteriaGroup.id === selection.criteriaGroup)?.position ?? 0)
    );
  }

  const selection = props.selection;
  return (
    <>
      {selection.alerts.map((alert) => (
        <div className={`message ${alert.type.toLowerCase()}`} key={alert.content}>
          <div className="icon" />
          <div
            className="content"
            dangerouslySetInnerHTML={{
              __html: sanitize(alert.content),
            }}
          />
        </div>
      ))}
      <div className="treatment-card" id={"selection_" + selection.uid}>
        <div className="criteria">
          {selection.criteria
            .filter((criterion) => criterion.isTreated)
            .map((criterion) => (
              <CriterionCard
                key={criterion.criterionId}
                criterion={criterion}
                printMode={props.printMode}
                updatable={false}
              />
            ))}
          <div className="white-space" />
          {!props.printMode &&
            (props.demoMode || selection.apiUrl) &&
            selection.availableTreatments.length != 0 && (
              <TreatmentOptionSelector
                selection={selection}
                onChange={props.onTreatmentOptionChange}
              />
            )}
        </div>
        <div className="treatment-options v-flex with-separator">
          {selection.selectedTreatments.sort(byPosition).map((treatment) => (
            <TreatmentViewer treatment={treatment} key={treatment.uid} />
          ))}
        </div>
      </div>
    </>
  );
}
